import React, { useState } from 'react'
import { Box } from '@mui/material'
import { makeStyles } from '@material-ui/core/styles'
import PoliceImg from 'src/assets/Buy_Policy_Images/trafficPolice.svg'

const BikeFundamental = () => {
  const classes = useStyles()
  const [isReadMore, setIsReadMore] = useState(false)

  return (
    <>
      <Box className={classes.bikeFundamentalContainer}>
        <Box className={classes.bikeFundamentalHeadingSection}>
          <Box className={classes.bikeFundamentalHeadingText}>
            A motorcycle insurance fundamentally &nbsp;
            <span className={classes.bikeFundamentalHeadingProtect}>
              ‘Protects the bike owner’
            </span>
            &nbsp;from financial stress arising &nbsp;
            <span className={classes.bikeFundamentalHeadingAccidents}>
              due to Accidents, Theft, or Natural Disasters.
            </span>
          </Box>
        </Box>
        <Box className={classes.fundamentalSection}>
          <Box className={classes.fundamentalLogoSection}>
            <Box className={classes.fundamentalLogoText}>
              You have to{' '}
              <span className={classes.fundamentalLogoTag}>know this</span>
            </Box>
            <Box>
              <img
                src={PoliceImg}
                alt='police-img'
                height={'246px'}
                width={'273.05px'}
              />
            </Box>
          </Box>
          <Box className={classes.fundamentalActSection}>
            <Box className={classes.fundamentalActText}>
              <p>
                <span className={classes.fundamentalActTextBold}>
                  The Motor Vehicles Act of 1988 necessitates
                </span>
                &nbsp; every bike to have minimum third-party insurance
                coverage.
              </p>
              <p>
                &nbsp; In Bharath, driving without insurance can lead to &nbsp;
                <span className={classes.fundamentalActTextBold}>
                  penalties such as license suspension
                </span>
                , vehicle impoundment, or fines of varying amounts.
              </p>

              {isReadMore ? (
                <>
                  <p>
                    To promote insurance for every vehicle on the road, &nbsp;
                    <span className={classes.fundamentalActTextBold}>
                      IRDAI mandated
                    </span>{' '}
                    that all new vehicles purchased after 2018 must opt for a
                    &nbsp;
                    <span className={classes.fundamentalActTextBold}>
                      &nbsp; 5-year Third-Party Insurance policy & 1-year Own
                      Damage policy
                    </span>
                    &nbsp; at the time of purchase.
                  </p>
                  <p>
                    This initiative allows citizens to obtain insurance at
                    budget-friendly premiums and eliminates the need for annual
                    policy renewals.
                  </p>
                </>
              ) : null}

              <Box
                id='readMoreBtn'
                className={classes.readMoreBtn}
                onClick={() => setIsReadMore((prevState) => !prevState)}
              >
                {isReadMore ? 'readless..' : ' readmore...'}
              </Box>
            </Box>
          </Box>
          <Box className={classes.fundamentalStatsSection}>
            <Box className={classes.fundamentalStatsSectionMain}>
              <Box className={classes.fundamentalStatsHeading}>Stats</Box>
              <Box className={classes.fundamentalStatsText}>
                <ol>
                  <li className={classes.listStyle}>
                    The fatality rate for bikes is roughly 30 times more
                    frequent than that for car accidents.
                  </li>
                  <li className={classes.listStyle}>
                    In bike accidents, a staggering 80% result in injuries or
                    worse, compared to 20% for cars.
                  </li>
                  <li className={classes.listStyle}>
                    The risk of injury is 20 times higher for bike riders above
                    the age of 40, compared to car drivers.
                  </li>
                </ol>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  )
}

export default BikeFundamental

const useStyles = makeStyles({
  bikeFundamentalContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 20,
    backgroundColor: '#FFFFFF',
    paddingLeft: 90,
    paddingRight: 90,
    paddingBottom: 30,
  },
  bikeFundamentalHeadingSection: {
    maxWidth: '1250px',
    maxHeight: '83px',
    textAlign: 'center',
  },
  bikeFundamentalHeadingText: {
    fontFamily: 'Roboto',
    fontSize: '20px',
    fontWeight: 300,
    lineHeight: '27px',
    letterSpacing: '0em',
    color: '#000000',
    maxWidth: '850px',
  },
  bikeFundamentalHeadingProtect: {
    fontFamily: 'Roboto',
    fontSize: '23px',
    fontWeight: 700,
    lineHeight: '30.87px',
    letterSpacing: '0em',
    color: '#4DC3E3',
  },
  bikeFundamentalHeadingAccidents: {
    fontFamily: 'Roboto',
    fontSize: '28px',
    fontWeight: 600,
    lineHeight: '37.58px',
    letterSpacing: '0em',
    color: '#B92250',
  },
  fundamentalSection: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 15,
    background:
      'linear-gradient(138.6deg, #EF669B -37.48%, rgba(255, 255, 255, 0) 56.86%)',
    borderRadius: '20px',
    padding: 20,
  },
  fundamentalLogoSection: {
    display: 'flex',
    flexDirection: 'column',
    gap: 10,
  },
  fundamentalStatsSection: {
    borderRadius: '20px',
    border: ' 2px dotted #DABBC7',
  },
  fundamentalLogoText: {
    fontFamily: 'Roboto',
    fontSize: '27px',
    fontWeight: 300,
    lineHeight: '38.39px',
    letterSpacing: '0em',
    color: '#000000',
  },
  fundamentalLogoTag: {
    fontFamily: 'Roboto',
    fontSize: '28px',
    fontWeight: 700,
    lineHeight: '39.81px',
    letterSpacing: '0em',
    color: '#000000',
  },
  fundamentalActText: {
    fontFamily: 'Roboto',
    fontSize: '17px',
    fontWeight: 400,
    lineHeight: '24.17px',
    letterSpacing: '0em',
    color: '#000000',
  },
  fundamentalActTextBold: {
    fontFamily: 'Roboto',
    fontSize: '18px',
    fontWeight: 700,
    lineHeight: '25.59px',
    letterSpacing: '0em',
    color: '#000000',
  },
  fundamentalStatsSectionMain: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  fundamentalStatsHeading: {
    fontFamily: 'Roboto',
    fontSize: '19px',
    fontWeight: 500,
    lineHeight: '27.07px',
    letterSpacing: '0em',
    color: '#804E61',
  },
  fundamentalStatsText: {
    fontFamily: 'Roboto',
    fontSize: '15px',
    fontWeight: 400,
    lineHeight: '19.38px',
    letterSpacing: '0em',
    color: '#804E61',
  },
  listStyle: {
    marginBottom: '8px',
  },
  readMoreBtn: {
    fontFamily: 'Roboto',
    fontSize: '17px',
    fontWeight: 400,
    textDecoration: 'underline',
    lineHeight: '24.17px',
    letterSpacing: '0em',
    color: '#1A90B0',
    cursor: 'pointer',
  },
})
